export class Captcha {
  uuid: string;
  code: string;

  constructor(uuid: string, code: string) {
    this.uuid = uuid;
    this.code = code;
  }
}
